<template>
	<div id="app">
		<div id="loading-wrapper">
			<div id="loading-text">RUNNING</div>
			<div id="loading-content"></div>
		</div>
		<header v-if="isLoggedIn" class="header container-fluid">
			<div class="navHead fixed-top">
			<b-navbar toggleable="lg" type="light" variant="transparent">
				<div class="brand">
					<a href="/"><span class="logo"></span></a>
					<h4 v-if="!isAdmin" class="pageTitle">{{ $t("header.title") }}</h4>
					<h4 v-if="isAdmin" class="pageTitle">Administrator Panel</h4>
				</div>
				<!-- <div v-if="isAdmin">
					<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

					<b-collapse class="forAdmin" id="nav-collapse" is-nav>
						<b-navbar-nav>
							<b-nav-item to="/event_participant">Participants</b-nav-item>
						</b-navbar-nav>

						<b-navbar-nav class="ml-auto">
							<b-nav-form>
								<b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
								<b-button size="sm" class="my-2 my-sm-0" type="submit"><b-icon icon="search"></b-icon></b-button>
							</b-nav-form>
							<b-nav-item-dropdown text="Language" right>
								<b-dropdown-item href="#">English</b-dropdown-item>
								<b-dropdown-item href="#">Indinesia</b-dropdown-item>
							</b-nav-item-dropdown>

							<b-nav-item-dropdown right>
								<template v-slot:button-content>
									<em>User</em>
								</template>
								<b-dropdown-item href="#">Profile</b-dropdown-item>
								<b-dropdown-item href="#" @click="logout">Sign Out</b-dropdown-item>
							</b-nav-item-dropdown>
						</b-navbar-nav>
					</b-collapse>
				</div> -->
				<div class="menuControl">
						<div class="languageSwitch">
							<a href="#" :class="enButton" @click.prevent="changeLanguage('en')">
								<svg-image image="flag-en"/>
							</a>
							<a href="#" :class="idButton" @click.prevent="changeLanguage('id')">
								<svg-image image="flag-id"/>
							</a>
						</div>
						<div class="logouter">
							<a href="/signin" @click.prevent="logout">
								<svg-image image="logout"/>
							</a>
						</div>
				</div>
			</b-navbar>
			</div>
		</header>
		<transition name="fade" mode="out-in">
			<router-view class="view"></router-view>
		</transition>
		<footer class="footer container-fluid">	
			<b-row>
				<!-- <b-col md="6">
				<div class="footerLogo">
					<a href="http://www.indonesia-athletics.org/"><img src="https://repository.bigchange.id/borobudur/PASI.png"></a>
					<a href="http://aims-worldrunning.org/races/10205.html"><img src="https://repository.bigchange.id/borobudur/IAAF-AIMS.png"></a>
					<a href="https://www.worldmarathonmajors.com/agwr/how-it-works/"><img src="https://repository.bigchange.id/borobudur/WAG.png"></a>
				</div>
				</b-col> -->
				<b-col md="12" class="footnote">
					<p>© Borobudur Marathon</p>
					<a href="https://borobudurmarathon.com/faq" target="_blank">{{ $t("footer.faq") }}</a> <a href="https://borobudurmarathon.com/terms-policy/" target="_blank">{{ $t("footer.tnp") }}</a> <a href="https://borobudurmarathon.com/contact" class="link" target="_blank">{{ $t("footer.contact") }}</a>
				</b-col>
			</b-row>
		</footer>
	</div>
</template>

<script>
	import SvgImage from './components/SvgImage.vue'
	export default {
		components: { SvgImage },
		data: () => ({
			signedin: false,
			enButton:undefined,
			idButton:undefined,
		}),
		created(){
			if (this.$http){
				this.$http.interceptors.response.use(undefined, (err)=>{
					return new Promise((resolve, reject)=>{
						if (err.response.status === 401) {
							console.log('Unauthorized, go to login.... ', this);
							this.logout();
						}
						throw err;
					});
				})
			}
		},
		mounted(){
			// console.log('mounted : ', this.$i18n);
			if (this.$i18n.locale == 'en'){
				this.enButton = 'active'
			} else {
				this.idButton = 'active'
			}
			if (localStorage&&localStorage.getItem('token')){
				this.$store.commit('auth_success', localStorage.getItem('token'))
			}
		},
		computed : {
			isLoggedIn : function(){ 
				console.log('is this one logged in? ', this.$store.getters.isLoggedIn);
				return this.$store.getters.isLoggedIn
			},
			isAdmin : function(){ 
				return this.$store.getters.isAdmin
			}
		},
		methods:{
			changeLanguage(lang){
				console.log('Change language to : ', this.$router.history.current.path);
				var _lang = 1;
				if (lang=='id'){
					_lang = 2;
				}
				this.$store.dispatch('SETLANGUAGE',{language:_lang})
					.then(s=>{				
						if (lang == 'en'){
							this.enButton = 'active'
							this.idButton = 'inactive'
						} else {
							this.idButton = 'active'
							this.enButton = 'inactive'
						}
						this.$i18n.locale = lang;
						this.$router.push({query:{lang:lang}})
					})
			},
			logout: function () {
				this.$store.dispatch('LOGOUT')
					.then(() => {
						this.$router.push('/signin')
					})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// App.vue